<template>
	<div>
		<vue-stars
			active-color="#ffdd00"
			inactive-color="#999999"
			shadow-color="#ffff00"
			hover-color="#dddd00"
			char="★"
			inactive-char=""
			:max="5"
			v-bind="$attrs"
			v-on:input="set"
			:value="Math.floor(current)"
			:readonly="readonly"
		/>
		({{current}})
	</div>
</template>

<script>
	// import { VueStars } from 'vue-stars';
	import VueStars from '~/components/refactor/VueStars.vue'

	export default {
		components: {
			VueStars,
		},
		inheritAttrs: false,
		props: {
			entity_id: { type: Number, required: true },
			entity: { type: String, required: true },
		},
		data() {
			return {
				current: 0,
				readonly: false,
			}
		},
		methods: {
			async set(v) {

				let _self = this,
					data = {
						id: _self.entity_id,
						entity: _self.entity,
						value: v,
					}

				await this.$api.setRating(data)
				_self.current = v
				_self.readonly = true
			},
		},

		mounted() {
			let _self = this,
				data = {
					id: _self.entity_id,
					entity: _self.entity,
				}

			this.$api.getRating(data).then(function (v) {
				_self.current = v.value
				_self.readonly = v.isVoted
			})
		},
	}
</script>
